import { Injectable, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class DocumentGeneratorService {

  constructor() { }

  fileExtension = '.xlsx';

  exportTableToExcel(table: ElementRef, fileName: string, fileExt?: string): void {
    console.log(table.nativeElement)
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table.nativeElement,{raw:true,cellDates:true});
    let wb: XLSX.WorkBook = XLSX.utils.book_new();
    ws['!cols']= [{ width:20}, { width: 20}, { width: 20 },{ width: 20 },{ width: 20}, { width: 40 }, { width: 20}, { width: 20 } ]
    console.log(ws)

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const ext = fileExt ? fileExt : this.fileExtension;
    const fn = fileName + '_' + Date.now();
    XLSX.writeFile(wb, fn + ext);
  }

  exportJsonToExcel(jsonData: any[], fileName: string, fileExt?: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const ext = fileExt ? fileExt : this.fileExtension;
    const fn = fileName + '_' + Date.now();
    XLSX.writeFile(wb, fn + ext);
  }


  testJsonToExcel(): void {
    const customers = [];
    for (let i = 0; i <= 25; i++) {
      customers.push({
        firstName: `first${i}`, lastName: `last${i}`,
        email: `abc${i}@gmail.com`, address: `000${i} street city, ST`, zipcode: `0000${i}`
      });
    }
    this.exportJsonToExcel(customers, 'customersExcel');
  }

  emitData = new Subject();
  convertToExcelToJson(e){
    console.log("Called")
    const target : DataTransfer  = <DataTransfer>(e.target);
    if(target.files.length != 1){
      console.log("Called")
      alert('Can Upload Only One File At a Time')
      throw new Error('Cannot use multiple files');
    }
    const reader : FileReader = new FileReader();
    let jsonData;
    reader.onload = (e) => {
      const bstr = e.target.result
      const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const firstSheetName: string = workbook.SheetNames[0];
      const worksheet: XLSX.WorkSheet = workbook.Sheets[firstSheetName];
      const data: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      jsonData = data
      console.log(data)
    }
    reader.readAsBinaryString(target.files[0]);
    this.emitData.next(jsonData)
  }

  getJsonSubject(){
    return this.emitData
  }
}
